module.exports = __webpack_public_path__ + "static/media/YF51_6.6425cb9d.jpg";